const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

const cloneJsonValue = (value) => {
	if (!value || typeof value !== 'object') return value;
	try {
		return JSON.parse(JSON.stringify(value));
	} catch {
		return value;
	}
};

export const appendUserMessageToConversationJson = (conversationValue, userMessage) => {
	const text = String(userMessage || '').trim();
	if (!text) return conversationValue;

	const nextEntry = {
		role: 'user',
		content: text,
	};

	if (Array.isArray(conversationValue)) {
		return [...conversationValue, nextEntry];
	}

	if (conversationValue && typeof conversationValue === 'object') {
		const source = cloneJsonValue(conversationValue);
		const candidateKeys = ['chat_conversation_json', 'messages', 'conversation', 'chat', 'history', 'turns'];
		const targetKey = candidateKeys.find((key) => Array.isArray(source[key])) || 'chat_conversation_json';
		const currentList = Array.isArray(source[targetKey]) ? source[targetKey] : [];
		source[targetKey] = [...currentList, nextEntry];
		return source;
	}

	return {
		chat_conversation_json: [nextEntry],
	};
};

export const sendChatConversationToBackend = async (chatConversationJson, options = {}) => {
	const response = await fetch(`${BACKEND_BASE_URL}/api/ai/chat`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			chatConversationJson,
			options,
		}),
	});

	const payload = await response.json().catch(() => ({}));

	if (!response.ok || !payload?.success) {
		throw new Error(payload?.error || `Chat request failed (${response.status})`);
	}

	return payload.data?.chat_conversation_json ?? payload.data?.chatConversationJson ?? payload.data ?? null;
};

const chatConversation = {
	appendUserMessageToConversationJson,
	sendChatConversationToBackend,
};

export default chatConversation;
